import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const baseUrl = 'https://demo.sirv.com/hang.jpg'

export default new Vuex.Store({
  state: {
    defaultUrl: `${baseUrl}`,
    url: `${baseUrl}?w=500`,
    url2: `${baseUrl}?w=1000`,
    reset: false
  },
  mutations: {
    CHANGE_COLOR (state, payload) {
      state.defaultUrl = payload.defaultUrl
      state.url = payload.url
      state.url2 = payload.url2
    },
    RESET (state) {
      state.reset = !state.reset
      state.defaultUrl = `${baseUrl}`
      state.url = `${baseUrl}?w=500`
      state.url2 = `${baseUrl}?w=1000`
    }
  },
  actions: {
    changeColor ({ commit }, params) {
      commit('CHANGE_COLOR', params)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
})
